<template>
  <div class="city-list">
    <div slot="bread">
</div>
    <list-page-header :page-info="pageInfo">
     <div slot="bread">
   <router-link :to="{ name: 'home' }" class="color-white mytitle">holywoodskyline.com</router-link><span class="mytitle"> / </span>
</div>
      <div class="hero-search__left">
        <div class="hero-search__select fw">
          <v-select :options="city" placeholder="Select Genre" @onselect="selectGenre"/>
        </div>
      </div>
      <v-link
        :to="searchUrl"
        class="hero-search__submit green"
        icon="icon-search"
        icon-position="left"
        title="SEARCH MOVIE"
        @click.native="selectGenre"
      />
    </list-page-header>    
    <div class="city-list__inner">     
      <container>
        <div class="section__title fw text-center"><span class="color-light-green">Popular</span> Series</div>
      <ContentLoader v-if="!featuredTVShows && !mobileCheck"
      :height="500">
        <rect x="2" y="0" rx="3" ry="3" width="195" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />       
      </ContentLoader>
      <ContentLoader v-if="!featuredTVShows && mobileCheck"
      :height="400">
        <rect x="2" y="0" rx="3" ry="3" width="400" height="400"/>     
      </ContentLoader>      
        <div class="city-list__list">
          <div
            v-for="(show, $index) in featuredTVShows"
            :key="show.id"
            class="city-list__col"
            :class="[$index === 0 ? 'col-xl-6 col-lg-6 col-md-6' : 'col-xl-3 col-lg-3 col-md-3']">
            <NetworkCard
              :network="show"
            />
          </div>
        </div>

        <div class="city-list-result">
          <div class="result-bracket">
            <div class="result-bracket__title">
              <span class="result-bracket__count" v-if="networks">{{ networks.length }}</span> Series Found!
            </div>
          </div>

      <div class="flex-row" v-if="networks">
        <div class="subpage-list__item"
             v-for="serie in networks"
             :key="serie.id">
          <SerieCard :city="serie" />
        </div>
  </div>

      <ContentLoader v-if="!networks && !mobileCheck"
      :height="400">>
        <p>&nbsp;</p>
        <rect x="2" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="202" y="0" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="0" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="75" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="75" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="75" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="150" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="150" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="150" rx="3" ry="3" width="95" height="70" />

        <rect x="2" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="103" y="225" rx="3" ry="3" width="95" height="70" /> 
        <rect x="202" y="225" rx="3" ry="3" width="95" height="70" />
        <rect x="303" y="225" rx="3" ry="3" width="95" height="70" />           
      </ContentLoader>

      <ContentLoader v-if="!cities && mobileCheck">
        <rect x="3" y="0" rx="3" ry="3" width="376" height="440" />      
      </ContentLoader>

<!--           <div class="city-list-result__list flex-row">
            <div class="city-list-result__item col-xl-3 col-md-4"
                 v-for="network in networks"
                 :key="network.id">
              <router-link :to="{ name: 'Network', params: { id: network.id, network: string_to_slug(network.name), genre: network.name }}" @click.native="onSelect(network)">
                <NetworkInfoCard
                  :network="network"
                />
              </router-link>
            </div>
          </div> -->

  <infinite-loading @infinite="infiniteHandler" spinner="waveDots" >
  <div slot="no-more"></div>
  <div slot="no-results"></div>
  </infinite-loading>

        </div>
      </container>
    </div>
  </div>
</template>

<script>
import ListPageHeader from '@/components/ListPageHeader'
import NetworkCard from '@/components/Network/NetworkCard'
import SerieCard from '@/components/SerieCard'
import NetworkInfoCard from '@/components/Network/NetworkInfoCard'
import { ContentLoader } from 'vue-content-loader'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
export default {
  name: 'TVSearch',
  components: {
    ListPageHeader, NetworkCard, SerieCard, NetworkInfoCard, ContentLoader, InfiniteLoading, 
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Genres',
       meta: [
         { vmid: 'description', name: 'description', content: this.pageInfo.text },
         { vmid: 'keywords', name: 'keywords', content: 'movie, hollywood movies, italian movies, german movies, french movies, english movies, superhero movies ,american movies, holywoodskyline, search movie' }
       ],
       link: [
         { vmid: 'canonical', rel: 'canonical', href: window.location.origin + '/genres' }
       ]      
    }
  },  
  data () {
    return {
      errors: [],
      counter: 1,
      page: 2,
      pageInfo: {
        icon: require('@/assets/img/icon-city.svg'),
        // title: '<span class="color-light-green">Choose Your </span> Movie Genre!',
        title: '<span class="color-light-green">holywood</span>skyline',
        text: '' //'You can find movies in your city, can track movie information, can learn prices and buy tickets !'
      },
      city: [],
      cityID: null,
      // featuredGenres: null,
      countries: [
        {name: 'All Countries', code: 'DE'},
        {name: 'Germany', code: 'DE'},
        {name: 'Sweden', code: 'SE'},
        {name: 'France', code: 'FR'},
        {name: 'Italy', code: 'IT'},
        {name: 'Denmark', code: 'DK'},
        {name: 'England', code: 'GB'},
        {name: 'United States', code: 'US'},
        {name: 'Canada', code: 'CA'},
        {name: 'New Zealand', code: 'NZ'},
        {name: 'Mexico', code: 'MX'},
        {name: 'Japan', code: 'JP'},
        {name: 'Russia', code: 'RU'},
        {name: 'Brasil', code: 'BR'},
        {name: 'Belgium', code: 'BE'},
        {name: 'Crotia', code: 'HR'},
        {name: 'Australia', code: 'AU'},
        {name: 'Finland', code: 'FI'},
        {name: 'Switzerland', code: 'CH'},
        {name: 'Chez Republic', code: 'CZ'},
        {name: 'Austria', code: 'AT'},
        {name: 'Luxemburg', code: 'LU'},
        {name: 'South Korea', code: 'KR'},
        {name: 'Spain', code: 'ES'},
        {name: 'Norwey', code: 'NO'},
        {name: 'Israel', code: 'IS,'}
      ],
      list1: [],
      networks: [],

      searchUrl: {},
      errors: [],
      featuredTVShows: null,
    }
  },
  methods: {
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },
    infiniteHandler ($state) {
      this.page += 1
      let self = this
      axios
       // .get(`/site/cities/dorms/${this.$route.params.city}?page=${this.page}`)
       // .get(`/3/tv/${this.counter}?api_key=a11ac97c6bdb99adc0845654be0902a8`)
        .get(`/3/discover/tv?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&sort_by=popularity.desc&page=2`)
        .then(response => {
          if (response.status == 200 && response.status != 34) {
            self.networks = response.data.results
         //     self.networks.push(response.data.results)
              // self.popupDorms = response.data.data.popups
            $state.loaded()
            self.counter += 10
            /*else {
              $state.complete()
            }*/
          }
        })
        .catch(e => {
          self.errors.push(e)
        })

      //this.Counter += 10
      this.counter = this.counter + 1
    //  let counter2 = this.counter + 9
      
      

      // this.counter += 10
    },     
    onSelect (city) {
      // console.log(opt)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', city.name)
      window.localStorage.setItem('genre', city.id)
    },
    selectGenre (opt) {
      // this.cityID = opt.id
      // this.searchUrl = { name: 'City', params: { slug: opt.slug, id: opt.id } }
      // console.log("sehir: " + this.$refs.myinput.value)
      // const selectedCity = this.$refs.myinput.value
      // let mycity = this.city.find(function (citty) { return citty.name == selectedCity } )
      // let slug = this.string_to_slug(this.$refs.myinput.value)
      window.localStorage.setItem('district_name', '')
      window.localStorage.setItem('studio', opt.slug)
      this.$router.push({ name: 'City', params: { city: opt.slug, id: opt.id } })
    },
    getPopularTVShows () {
      let self = this
      //axios.get('/site/home/cities?take=7')
      axios.get('/3/tv/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US&page=1')
        .then(response => {
          self.featuredTVShows = response.data.results
          /*
              self.featuredTVShows.forEach((data) => {
                data.slug = string_to_slug(data.name)
            })*/
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCityList () {
      let self = this
      axios.get('/3/genre/movie/list?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US')
        .then(response => {
       //   self.genres = response.data.genres
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCities () {
      let self = this
      axios.get('/3/discover/movie?api_key=a11ac97c6bdb99adc0845654be0902a8&with_genres=28&page=2')
        .then(response => {
           self.city = response.data.results
/*          response.data.forEach(function(element) {
          self.city.push(element.name)
         })      */
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  created () {
   this.getPopularTVShows()
  //  this.getCities()
    this.getCityList() 
  },
  computed: {
    mobileCheck() {
     var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check
  },     
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/city-list";
</style>
